import React from 'react'
import senddata from "../../Data/data.js";
import logoimg from '../../assets/MK1.3.png'
import { useLocation, useNavigate } from 'react-router-dom';

function GroupStudents() {

  const location = useLocation();
  const navigate = useNavigate()

  var {students,groupName} = location.state;

  console.log(students);

  const editStudent =(student) =>{
    navigate("/student",{ state: student });
  }


  return (
    <div className=' bg-[#1A1A4C] text-white flex flex-col min-h-screen text-base font-semibold pb-40 '>
      {/* headers */}
        <div className='headers  '>
          <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto'/>
        </div>

        <div className='flex flex-col items-center mt-16'>
            <h2 className='border-b-2 border-[#e9ad03]'> {groupName} </h2>
        </div>

        {students.length && (
            <div className='w-full overflow-x-auto scrollbar-hidden px-6 mt-8 '>
              <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' > 
                  <div className='text-base w-[150px] text-center'>الاسم</div>
                  <div className='text-base w-[150px] text-center'>اسم المستخدم</div>
                  <div className='text-base w-[150px] text-center'>رقم الهاتف</div>
                  <div className='text-base w-[150px] text-center'>رقم ولي الأمر</div>
                  <div className='text-base w-[100px] text-center'>السنة</div>
                  <div className='text-base w-[150px] text-center'>المجموعة</div>
                  <div className='text-base w-[100px] text-center'>الحظر</div>
                  <div className='text-base w-[100px] text-center'>تفاصيل</div>
                </div>
              {students?.map((student) => (
                <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' key={student.id}> 
                  <div className='text-base w-[150px] text-center'>
                    {student.FirstName + ' ' + student.LastName}</div>
                  <div className='text-base w-[150px] text-center'>{student.email}</div>
                  <div className='text-base w-[150px] text-center'>{student.mobile}</div>
                  <div className='text-base w-[150px] text-center'>{student.parentPhoneNumber}</div>
                  <div className='text-base w-[100px] text-center'>{student.level}</div>
                  <div className='text-sm w-[150px] text-center'>{student.groupName}</div>
                  <div className='text-base w-[100px] text-center'>{student.isBlocked?"تم الحظر":"نشط"}</div>
                  <div className='text-base w-[100px] text-center flex justify-center'><p onClick={()=>{editStudent(student)}} className='  w-fit rounded-full cursor-pointer'>🕵️‍♀️</p> </div>
                </div>
              ))}
            </div>
          )}
      
    </div>
  )
}

export default GroupStudents
